const SENSITIVE_QUERY_PARAMETER_PATTERN =
  /^(?:token|access_token|id_token|auth|authorization|password|secret|signature|policy|api_key|key|credential|googleaccessid|expires|si|x-amz-.+)$/i;

export function getSourceUrlWithoutCredentials(sourceUrl: unknown): string | null {
  if (typeof sourceUrl !== "string" || !sourceUrl) return null;
  try {
    const parsedUrl = new URL(sourceUrl);
    if (parsedUrl.protocol !== "http:" && parsedUrl.protocol !== "https:") return null;
    parsedUrl.username = "";
    parsedUrl.password = "";
    for (const queryParameterName of Array.from(parsedUrl.searchParams.keys())) {
      if (SENSITIVE_QUERY_PARAMETER_PATTERN.test(queryParameterName)) {
        parsedUrl.searchParams.delete(queryParameterName);
      }
    }
    return parsedUrl.toString();
  } catch {
    return null;
  }
}
